import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  textBoxTrim,
  themeColor
} from '@dboxdev/ui-components'

export const Wrapper = styled.section`
  padding: ${calculateResponsiveSize(150)} 0 0 0;
  position: relative;
  ${mediaMax('mobile')} {
    padding: ${calculateResponsiveSize(60)} 0 0 0;
  }
`

export const FormWrapper = styled.div`
  width: ${calculateResponsiveSize(750)};
  margin: 0 auto;
  transition: opacity 1s;
  opacity: 1;
  position: relative;
  z-index: 1;
  &.show {
    opacity: 1;
  }
  &.hide {
    opacity: 0;
  }
  ${mediaMax('mobile')} {
    width: 100%;
    padding: 0 ${calculateResponsiveSize(56)};
  }
`

export const Title = styled.h1`
  ${textBoxTrim}
  margin: 0 0 ${calculateResponsiveSize(30)} 0;
  text-align: center;
  font-family: var(--font-secondary);
  font-size: ${calculateResponsiveSize(60)};
  color: ${themeColor('accentColor')};
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: ${calculateResponsiveSize(0.48)};
  ${mediaMax('mobile')} {
    margin: 0 0 ${calculateResponsiveSize(32)} 0;
    font-size: ${calculateResponsiveSize(30)};
    letter-spacing: ${calculateResponsiveSize(0.177)};
  }
`

export const SubTitle = styled.h2`
  ${textBoxTrim}
  margin: 0 0 ${calculateResponsiveSize(60)} 0;
  text-align: center;
  font-size: ${calculateResponsiveSize(25)};
  font-weight: 300;
  line-height: 1.12;
  letter-spacing: ${calculateResponsiveSize(0.48)};
  text-transform: uppercase;
  ${mediaMax('mobile')} {
    margin: 0 0 ${calculateResponsiveSize(32)} 0;
    font-size: ${calculateResponsiveSize(14)};
    line-height: 1.2;
    letter-spacing: ${calculateResponsiveSize(0.177)};
  }
`

export const Description = styled.div`
  ${textBoxTrim}
  margin: 0 0 ${calculateResponsiveSize(22)} 0;
  text-align: center;
  font-size: ${calculateResponsiveSize(20)};
  color: ${themeColor('accentColor')};
  font-weight: 300;
  line-height: 1.1;
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(246)};
    margin: 0 auto ${calculateResponsiveSize(47)} auto;
    font-size: ${calculateResponsiveSize(12)};
  }
`

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calculateResponsiveSize(28)};
  width: 100%;
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  ${mediaMax('mobile')} {
    gap: ${calculateResponsiveSize(16)};
    font-size: ${calculateResponsiveSize(12)};
  }
`

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calculateResponsiveSize(5)};
  width: 100%;
`

export const Row = styled.div``

export const ConsentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${calculateResponsiveSize(23)};
  padding: ${calculateResponsiveSize(48)} 0 0 0;
  font-size: ${calculateResponsiveSize(16)};
  line-height: 1.1;
  > div {
    width: ${calculateResponsiveSize(567)};
  }
  ${mediaMax('mobile')} {
    gap: ${calculateResponsiveSize(17)};
    padding: ${calculateResponsiveSize(12)} 0 0 0;
    font-size: ${calculateResponsiveSize(9)};
    > div {
      width: ${calculateResponsiveSize(252)};
    }
  }
`

export const Disclaimer = styled.div`
  width: ${calculateResponsiveSize(600)};
  margin: 0 auto;
  text-align: center;
  font-size: ${calculateResponsiveSize(16)};
  line-height: 1.1;
  a {
    text-decoration: underline;
  }
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(252)};
    font-size: ${calculateResponsiveSize(9)};
  }
`

export const SubmitError = styled.div`
  width: ${calculateResponsiveSize(600)};
  margin: ${calculateResponsiveSize(16)} auto 0;
  text-align: center;
  font-size: ${calculateResponsiveSize(16)};
  line-height: 1.1;
  color: red;
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(252)};
    font-size: ${calculateResponsiveSize(9)};
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${calculateResponsiveSize(28)} 0 0 0;
  ${mediaMax('mobile')} {
    padding: ${calculateResponsiveSize(12)} 0 0 0;
  }
`

export const ThanksMessage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${calculateResponsiveSize(100)};
  opacity: 0;
  visibility: hidden;
  z-index: 2;
  &.show {
    animation: 2s ease 0s normal forwards 1 thanksMessageFadeIn;
    @keyframes thanksMessageFadeIn {
      0% {
        opacity: 0;
        visibility: hidden;
      }
      100% {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  & .gatsby-image-wrapper {
    width: ${calculateResponsiveSize(1000)};
  }
  ${mediaMax('mobile')} {
    justify-content: flex-start;
    gap: ${calculateResponsiveSize(32)};
    padding: ${calculateResponsiveSize(100)} 0 0 0;
    & .gatsby-image-wrapper {
      width: ${calculateResponsiveSize(368)};
      margin: ${calculateResponsiveSize(12)} 0 0 0;
    }
  }
`

export const ThanksMessageTitle = styled.h2`
  ${textBoxTrim}
  margin: 0;
  text-align: center;
  font-family: var(--font-secondary);
  font-size: ${calculateResponsiveSize(60)};
  color: ${themeColor('accentColor')};
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: ${calculateResponsiveSize(0.48)};
  ${mediaMax('mobile')} {
    font-size: ${calculateResponsiveSize(30)};
    letter-spacing: ${calculateResponsiveSize(0.177)};
  }
`

export const ThanksMessageDescription = styled.div`
  ${textBoxTrim}
  text-align: center;
  font-size: ${calculateResponsiveSize(20)};
  color: ${themeColor('accentColor')};
  font-weight: 300;
  line-height: 1.1;
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(294)};
    font-size: ${calculateResponsiveSize(12)};
  }
`
